
export const Routing = {
  Initial: `/`,
  Specialities: `/specialities`,
  Profile: `/settings/profile`,
  AddSpecialities: `/specialities/add`,
  EditSpecialities: `/specialities/edit/:specialityId`,
  Professionals: `/professionals`,
  AddProfessionals: `/professions/add`,
  ViewProfessionals: `/professions/view/:professionId`,
  EditProfessionals: `/professions/edit/:professionId`,
  Establishment: `/establishments`,
  AddEstablishment: `/establishments/add`,
  EditEstablishment: `/establishments/edit/:establishmentId`,
  EstablishmentImages: `/establishment-images/:id`,
  ManageEstablishmentHours: `/establishments/manage-hours/:establishmentId`,
  AddEstablishmentWorkingHours: `/establishments/manage-hours/add/:establishmentId`,
  EditEstablishmentWorkingHours: `/establishments/manage-hours/edit/:hoursId`,
  AddEstablishmentImages: `/add-establishment-images/:id`,
  ManageEstablishmentHoliday: `/establishments/manage-holidays/:establishmentId`,
  AddEstablishmentHoliday: `/establishments/manage-holidays/add/:establishmentId`,
  EditEstablishmentHoliday: `/establishments/manage-holidays/edit/:holidayId`,
  AddEstablishmentImages: `/add-establishment-images`,
  ViewEstablishment: `/establishments/view/:establishmentId`,
  EstablishmentBannerImage: `/establishment-banner-images`,
  Departments: `/departments`,
  AddDepartment: `/departments/add`,
  EditDepartment: `/departments/edit/:departmentId`,
  ManageDepartmentHolidays: "/departments/manage-holidays/:departmentId",
  AddDepartmentHolidays: "/departments/manage-holidays/add/:departmentId",
  EditDepartmentHolidays: "/departments/manage-holidays/edit/:holidayId",
  AddDepartmentWorkingHours: `/departments/manage-hours/add/:departmentId`,
  EditDepartmentWorkingHours: `/departments/manage-hours/edit/:hoursId`,
  Insurances: `/insurances`,
  PlanDetailPage: `/plan/:planId`,
  NetworkDetailPage: `/network/:networkId`,
  CompanyDetailPage: `/company/:companyId`,
  EstablishmentTypes: `/establishmenttypes`,
  EstablishmentSubTypes: `/establishment-sub-types`,
  Brands: `/admin/brands`,
  ViewBrands: `/brand-management/:brandId`,

  ProfessionsTypes: `/professionstypes`,
  Banners: `/banners`,
  Nationalities: `/nationalities`,

  Facilities: `/facilities`,
  ManageRoles: `/manage-roles`,
  Services: `/services`,
  Register: `/register`,
  Languages: `/languages`,
  Cities: `/cities`,
  FAQ: `/faq`,
  Packages: `/packages`,
  Demo: `/demo-login`,
  Zones: `/zones`,
  BiomarkerManagement: `/biomarkers`,
  ViewBookings: `/bookings/view/:bookingId`,
  ServiceBooking: `/service-bookings/view/:bookingId`,
  ServiceBookingPage: `/service-bookings`,
  ViewBiomarker: `/biomarkers/:id/view`,
  ViewBiomarkerGroup: `/biomarker-groups/:id/view`,
  ViewPackage: `/packages/:id/view`,
  PackageBundle: `/package-bundles`,
  PackageBundleB2b: `/package-bundles/b2b`,
  PackageBundleB2bDetail: `/b2b-subscriptions/view/:id`,
  PackageBundleDetail: `/package-bundles/:bundleId`,
  Bookings: `/bookings`,
  Notifications: `/notifications`,
  Promotion: '/promotions',
  NotificationDetail: `/notifications/:id`,
  Pharmacy: `/pharmacy`,
  PharmacyProductDetail: `/pharmacy/product/:productId`,
  BundlePurchaseDetailPage: `/bundle-purchases/:purchaseId`,
  PillPackManagement: `/pillpack-management`,
  ViewPillPackManagement: `/pillpack/prescriptions/:prescriptionId`,
  ViewDepartment: `/departments/view/:departmentId`,
  ManageDepartmentHours: `/departments/manage-hours/:departmentId`,
  Logout: `/settings/logout`,
  InsuranceLeads: `/insurance-leads`,
  ViewInsuranceLeads: `/insurance-leads/view/:id`,
  NotFound: `*`,

};
